import { render, staticRenderFns } from "./IconFavoriteNot.vue?vue&type=template&id=b0dd707e&scoped=true"
import script from "./IconFavoriteNot.vue?vue&type=script&lang=js"
export * from "./IconFavoriteNot.vue?vue&type=script&lang=js"
import style0 from "./IconFavoriteNot.vue?vue&type=style&index=0&id=b0dd707e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dd707e",
  null
  
)

export default component.exports